import { css, IEOnly, styled } from '../../../common.styles';
import { HtmlHReset } from '../../../styles/general/reset';
import { FlexHorizontalCenter } from '../../layout/general/layout';
import { PeuFontSize, Typography } from '../../typography/peugeot/peu-typography';
import { baseColor, primaryColor, secondaryColor } from '../../../styles/general/theme';

export const CategoryRow = styled.div`
  width: 100%;
  position: relative;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  background-color: ${baseColor(900)};
  margin-bottom: 30px;

  ${IEOnly(css`
    display: flex;
    flex-flow: row wrap;
  `)}
`;

export const Category = styled.h2<{ selected?: boolean; size: PeuFontSize }>`
  ${HtmlHReset}
  ${FlexHorizontalCenter}
  ${Typography.styles.PeuTitleStyle}
  align-items: center;
  padding: 15px;
  color: ${secondaryColor(300)};
  font-family: ${(p) => p.theme.font.normal};
  cursor: pointer;
  position: relative;
  @media (max-width: ${(p) => p.theme.breakPoint.tablet}px) {
    font-size: ${(p) => p.theme.fontSize.normal - 2}px;
  }
  @media (max-width: ${(p) => p.theme.breakPoint.mobile}px) {
    font-size: ${(p) => p.theme.fontSize.normal}px;
  }
  ${(p) =>
    p.selected
      ? css`
          color: ${p.theme.color.base[100]};
          ${Typography.styles.PeuTitleStyle};

          :after {
            content: '';
            display: block;
            position: absolute;
            bottom: -1px;
            z-index: 1;
            width: 100%;
            border-bottom: 3px solid ${primaryColor(200)};
          }
        `
      : ``}

  ${IEOnly(css`
    flex: 0 1 205px;
  `)}
`;

export const TabSeparator = styled.div`
  position: absolute;
  z-index: 0;
  bottom: 0;
  background-color: ${baseColor(500)};
  height: 1px;
  width: 100%;

  ${IEOnly(css`
    position: static;
    margin-top: -1px;
  `)}
`;
